import Api from './Api.service';

export default class ComisionService {

    static ObtenerTodo() {
        return Api.get('comision/todo');
    }
    static Insertar(model) {
        return Api.post('comisioninsertar',model);
    }
    static Editar(model) {
        return Api.put('comisioneditar',model);
    }
    static Eliminar(rolid) {
        return Api.delete(`comision/${comisionid}`);
    }

}